import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup } from '@angular/forms/src/model';
import { ImageCarouselComponent } from '../image-carousel/image-carousel.component';
import { MarketDateCommentImages } from '../../entities/market-date-comment.model';
import { ApiService } from '../services/api.service';
import { Observable } from 'rxjs/Observable';
import { Contact } from '../../entities';
import {Log} from '../../entities/log.model';

@Component({
  selector: 'app-mail-composer',
  templateUrl: './mail-composer.component.html'
})
export class MailComposerComponent implements OnInit {

  @ViewChild('successModal') private successModal;
  @ViewChild('errorModal') private errorModal;
  @Input() marketdateCommentsImages: Array<MarketDateCommentImages>;
  @Input() mailBody = '';
  @Input() mailSubject = '';
  @Input() marketdayNumber: number = null;
  @Input() marketdayKeyword = '';
  @Output() mailLog: EventEmitter<Log>;
  allMarketdateCommentsImages: Array<string>;
  mailForm: FormGroup;
  sending = false;
  employees: Array<Contact> = [];
  showFormErrors = false;

  constructor(public activeModal: NgbActiveModal,
              public formBuilder: FormBuilder,
              public modalService: NgbModal,
              private apiService: ApiService) {
    this.mailLog = new EventEmitter<Log>(true);
  }

  ngOnInit(): void {
    this.getEmployees();

    this.mailForm = this.formBuilder.group({
      to: ['', Validators.compose([Validators.required, Validators.email])],
      subject: [this.mailSubject, Validators.required],
      message: [this.mailBody, Validators.required],
      marketdayNumber: [this.marketdayNumber],
      marketdayKeyword: [this.marketdayKeyword]
    });

    if (this.marketdateCommentsImages && this.marketdateCommentsImages.length > 0
      && this.marketdateCommentsImages.some(e => e.images && e.images.length > 0)) {

      // push base64 images in this.allMarketdateCommentsImages to below form
      this.allMarketdateCommentsImages = [];
      this.marketdateCommentsImages.forEach(mdcis =>
        mdcis.images.forEach(mdci => this.allMarketdateCommentsImages.push(mdci.base64)));

      // strip base64 data for form
      this.marketdateCommentsImages.forEach(mdci => mdci.images.map(m => m.base64 = null));
      this.mailForm.addControl('marketdateCommentsImages',
        this.formBuilder.control(this.marketdateCommentsImages));
    }
  }

  getEmployees() {
    this.apiService.find<Contact>(Contact, 'employees/').subscribe((employees: Array<Contact>) => {
        this.employees = employees
          .filter((employee: Contact) => employee.category.indexOf('Mitarbeiter | Verwaltung') > -1 && employee.email);
      });
  }

  showImageCarousel(commentImageId) {
    const imageCarouselRef: NgbModalRef = this.modalService.open(ImageCarouselComponent, {size: 'lg', windowClass: 'l'});
    imageCarouselRef.componentInstance.title = commentImageId;
    imageCarouselRef.componentInstance.images = this.allMarketdateCommentsImages;
    imageCarouselRef.componentInstance.imageIndex = commentImageId;
  }

  onSubmit() {
    if (this.mailForm.valid) {
      let apiPath = 'backoffice/mail-marketdate-comment';
      if (!this.allMarketdateCommentsImages) {
        apiPath = 'backoffice/mail';
      }
      this.sending = true;
      this.mailForm.disable();
      this.apiService.postRegular(this.mailForm.value, apiPath).subscribe(
        (result) => {
          const log: Log = JSON.parse(result._body);
          this.mailLog.emit(log);
          this.sending = false;
          this.mailForm.enable();
          this.activeModal.close();
          this.modalService.open(this.successModal, {size: 'sm', windowClass: 'm pt-2', backdrop: 'static'});
        }, (error) => {
          console.log('Error sending mail', error);
          this.sending = false;
          this.mailForm.enable();
          this.modalService.open(this.errorModal, {size: 'sm', windowClass: 'm pt-2', backdrop: 'static'});
        }
      );
    } else {
      this.showFormErrors = true;
    }
  }

  close() {
    this.activeModal.close();
  }

  search = (text$: Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map(term => this.employees
        .filter((employee: Contact) => employee.email.toLowerCase().indexOf(term.toLowerCase()) > -1
        || employee.firstname.toLowerCase().indexOf(term.toLowerCase()) > -1
        || employee.lastname.toLowerCase().indexOf(term.toLowerCase()) > -1
        || (employee.firstname + ' ' + employee.lastname).toLowerCase().indexOf(term.toLowerCase()) > -1
        || employee.merchantNumber.toString().toLowerCase().indexOf(term.toLowerCase()) > -1)
        .slice(0, 15)
        .sort((a: Contact, b: Contact) => a.firstname.localeCompare(b.firstname))
        .map((employee: Contact) => employee.email));

  formatter = (result: string) =>
    this.employees.find((e: Contact) => e.email === result).firstname
    + ' ' + this.employees.find((e: Contact) => e.email === result).lastname
    + ((this.employees.find((e: Contact) => e.email === result).merchantNumber) ?
      (' (' + this.employees.find((e: Contact) => e.email === result).merchantNumber + ')') : '')
    + ' <' + this.employees.find((e: Contact) => e.email === result).email + '>';

}



// WEBPACK FOOTER //
// ./src/app/shared/mail-composer/mail-composer.component.ts